import { useEffect } from "react";
import { api } from "../data";
import { StartLaden } from "../components/Ladeschirm";

/** Ziel nach dem Abmelden: die Anmeldung des Kundenportals mit dem Hinweis auf den internen Bereich */
export const INTERN_HINWEIS_ZIEL = "/anmelden?hinweis=intern";

/**
 * Reines Mitarbeiterkonto im Kundenportal (Inhaber 03.11.2026, lib/bereich.ts nurInternesKonto): keine Einrichtung „Wie heißt
 * deine Agentur?“, sondern im Kundenportal abmelden (nur diese Sitzung; eine interne Sitzung bleibt bestehen) und auf der
 * Anmeldeseite den Hinweis auf /intern/anmelden zeigen. Die Seite lädt dabei neu, damit kein Zwischenstand stehen bleibt.
 */
export function InternesKontoHinweis() {
  useEffect(() => {
    void api.signOut().catch(() => undefined).finally(() => window.location.replace(INTERN_HINWEIS_ZIEL));
  }, []);
  return <StartLaden />;
}
